const DEFAULT_TIME_ZONE = 'America/Sao_Paulo';

function normalizeStationId(stationId = '') {
  return stationId
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-');
}

export function getStationTimeZone(stationId?: string) {
  const normalizedId = normalizeStationId(stationId);

  if (
    normalizedId.includes('alto-solimoes') ||
    normalizedId.includes('tabatinga')
  ) {
    return 'America/Eirunepe';
  }

  if (normalizedId.includes('amazonas') || normalizedId.includes('manaus')) {
    return 'America/Manaus';
  }

  return DEFAULT_TIME_ZONE;
}

function getPart(
  parts: Intl.DateTimeFormatPart[],
  type: Intl.DateTimeFormatPartTypes,
) {
  return parts.find((part) => part.type === type)?.value ?? '';
}

export function getStationDateTime(stationId: string, instant = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: getStationTimeZone(stationId),
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(instant);

  const year = getPart(parts, 'year');
  const month = getPart(parts, 'month');
  const day = getPart(parts, 'day');
  const hour = getPart(parts, 'hour');
  const minute = getPart(parts, 'minute');

  return {
    date: `${year}-${month}-${day}`,
    time: `${hour}:${minute}`,
    timeZone: getStationTimeZone(stationId),
  };
}

export function getStationCurrentDate(stationId: string, instant = new Date()) {
  return getStationDateTime(stationId, instant).date;
}
